//Todo: Mohon Dibaca Catatan Dibawah!!!!!
/**
 * Catatan: Jika mau menambah role baru dan menu baru untuk role itu, maka perlu menambahkan role baru di RoutePermittedRole di file AppConst.js
 * Kemudian, tambahkan role baru ke file RouteGenerator.js pada line 89. Okay?
 */

//Todo: Bila ingin dinamis, maka list role harus dari api dan ditambahkan pada file RouteGenerator.js

export const adminRoutes = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    messageId: 'Dashboard',
    type: 'nonGroup',
    url: '/dashboard',
    icon: 'Dashboard',
  },
  {
    id: 'data-pegawai',
    title: 'Data Pegawai',
    messageId: 'Data Pegawai',
    type: 'group',
    icon: 'People',
    children: [
      {
        id: 'data-asn',
        title: 'Data Pegawai ASN',
        messageId: 'Data Pegawai ASN',
        type: 'item',
        exact: false,
        url: '/pegawai/asn',
      },
      {
        id: 'data-kontrak',
        title: 'Data Pegawai Kontrak',
        messageId: 'Data Pegawai Kontrak',
        type: 'item',
        exact: false,
        url: '/pegawai/kontrak',
      },
      {
        id: 'data-jpt-non-pns',
        title: 'Data Pegawai JPT Non PNS',
        messageId: 'Data Pegawai JPT Non PNS',
        type: 'item',
        exact: false,
        url: '/pegawai/jpt-non-pns',
      },
      {
        id: 'data-pjlp',
        title: 'Data Pegawai PJLP (Outsource)',
        messageId: 'Data Pegawai PJLP (Outsource)',
        type: 'item',
        exact: false,
        url: '/pegawai/pjlp',
      },
      {
        id: 'laporan-khusus',
        title: 'Laporan Khusus',
        messageId: 'Laporan Khusus',
        type: 'collapse',
        children: [
          // {
          //   id: 'drh',
          //   title: 'Daftar Riwayat Hidup',
          //   messageId: 'Daftar Riwayat Hidup',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/drh',
          // },
          {
            id: 'pegawai-akan-pensiun',
            title: 'Daftar Pegawai akan Pensiun',
            messageId: 'Daftar Pegawai akan Pensiun',
            type: 'item',
            exact: false,
            url: '/pegawai/laporan-khusus/pegawai-akan-pensiun',
          },
          // {
          //   id: 'mutasi',
          //   title: 'Daftar Mutasi',
          //   messageId: 'Daftar Mutasi',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/mutasi',
          // },
          // {
          //   id: 'informasi-jabatan',
          //   title: 'Informasi Jabatan',
          //   messageId: 'Informasi Jabatan',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/informasi-jabatan',
          // },
          // {
          //   id: 'aktivitas-operator',
          //   title: 'Aktivitas Operator',
          //   messageId: 'Aktivitas Operator',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/aktivitas-operator',
          // },
          // {
          //   id: 'export-data-pegawai',
          //   title: 'Export Data Pegawai',
          //   messageId: 'Export Data Pegawai',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/export-data',
          // },
          // {
          //   id: 'surat-dp3-pegawai',
          //   title: 'Persuratan/Surat DP3 Pegawai',
          //   messageId: 'Persuratan/Surat DP3 Pegawai',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/surat-dp3-pegawai',
          // },
          {
            id: 'pegawai-tugas-izin-belajar',
            title: 'Daftar Pegawai Tugas Belajar',
            messageId: 'Daftar Pegawai Tugas Belajar',
            type: 'item',
            exact: false,
            url: '/pegawai/laporan-khusus/pegawai-tugas-izin-belajar',
          },
          // {
          //   id: 'rekapitulasi-pegawai-non-pns',
          //   title: 'Rekapitulasi Pegawai Non PNS',
          //   messageId: 'Rekapitulasi Pegawai Non PNS',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/rekapitulasi-pegawai-non-pns',
          // },
          // {
          //   id: 'data-pegawai-perlu-diperbaiki',
          //   title: 'Data Pegawai Perlu Diperbaiki',
          //   messageId: 'Data Pegawai Perlu Diperbaiki',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/data-pegawai-perlu-diperbaiki',
          // },
          // {
          //   id: 'daftar-nominatif',
          //   title: 'Daftar Nominatif',
          //   messageId: 'Daftar Nominatif',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/daftar-nominatif',
          // }
        ],
      },
    ],
  },
  {
    id: 'profil-talenta',
    title: 'Profil Talenta',
    messageId: 'Profil Talenta',
    type: 'nonGroup',
    url: '/profil-talenta',
    icon: 'AssignmentInd',
  },
  {
    id: 'laporan',
    title: 'Laporan',
    messageId: 'Laporan',
    type: 'group',
    icon: 'Assessment',
    children: [
      {
        id: 'rekapitulasi',
        title: 'Rekapitulasi',
        messageId: 'Rekapitulasi',
        type: 'collapse',
        exact: true,
        icon: 'Analytics',
        children: [
          {
            id: 'rekapitulasi-pegawai',
            title: 'Rekapitulasi Pegawai',
            messageId: 'Rekapitulasi Pegawai',
            type: 'item',
            exact: true,
            icon: 'Analytics',
            url: '/laporan-umum/rekapitulasi',
          },
          {
            id: 'rekapitulasi-formasi-peta-jabatan',
            title: 'Rekapitulasi Formasi Peta Jabatan',
            messageId: 'Rekapitulasi Formasi Peta Jabatan',
            type: 'item',
            exact: true,
            icon: 'Analytics',
            url: '/laporan-jumlah-jabatan-unit',
          },
          {
            id: 'rekapitulasi-jabatan-fungsional',
            title: 'Rekapitulasi Jabatan Fungsional',
            messageId: 'Rekapitulasi Jabatan Fungsional',
            type: 'item',
            exact: false,
            icon: 'Leaderboard',
            url: '/laporan-umum/jabfung/pejabat-fungsional',
          },
          {
            id: 'rekapitulasi-penghargaan-asn',
            title: 'Rekapitulasi Penghargaan ASN',
            messageId: 'Rekapitulasi Penghargaan ASN',
            type: 'item',
            exact: true,
            icon: 'Analytics',
            url: '/laporan-umum/rekapitulasi-penghargaan-asn',
          },
        ]
      },
      {
        id: 'daftar-nominatif-pegawai',
        title: 'Daftar Nominatif Pegawai',
        messageId: 'Daftar Nominatif Pegawai',
        type: 'item',
        exact: false,
        icon: 'Summarize',
        url: '/laporan-umum/laporan',
      },
      // {
      //   id: 'laporan-jumlah-jabatan-unit',
      //   title: 'Laporan Jumlah Jabatan Unit',
      //   messageId: 'Laporan Jumlah Jabatan Unit',
      //   type: 'item',
      //   exact: false,
      //   icon: 'Leaderboard',
      //   url: '/laporan-jumlah-jabatan-unit',
      // },
      {
        id: 'grafik',
        title: 'Grafik',
        messageId: 'Grafik',
        type: 'item',
        exact: false,
        icon: 'PieChart',
        url: '/laporan-umum/grafik',
      },
    ],
  },
  {
    id: 'monitoring',
    title: 'Monitoring',
    messageId: 'Monitoring',
    type: 'nonGroup',
    url: '/monitoring/data-asn',
    icon: 'TextSnippet',
  },
  {
    id: 'manajemen',
    title: 'Tim Kerja',
    messageId: 'Tim Kerja',
    type: 'nonGroup',
    url: '/manajemen/anggota-tim-kerja',
    icon: 'Dashboard',
  },
  {
    id: 'pengaturan',
    title: 'Pengaturan',
    messageId: 'Pengaturan',
    type: 'group',
    icon: 'Dashboard',
    children: [
      {
        id: 'pengguna',
        title: 'Pengguna',
        messageId: 'Pengguna',
        type: 'item',
        exact: true,
        url: '/pengaturan/pengguna',
      },
      // {
      //   id: 'hak-akses',
      //   title: 'Hak Akses',
      //   messageId: 'Hak Akses',
      //   type: 'item',
      //   exact: true,
      //   url: '/pengaturan/hak-akses',
      // },
    ]
  },
  {
    id: 'ipasn',
    title: 'IPASN',
    messageId: 'IPASN',
    type: 'group',
    icon: 'MilitaryTech',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        messageId: 'Dashboard',
        type: 'item',
        exact: true,
        isNewWindow: '1',
        icon: 'GridView',
        url: 'http://ropeg.kkp.go.id:4080/ip-asn',
      },
      {
        id: 'detai-ipasn',
        title: 'Detail',
        messageId: 'Detail',
        type: 'item',
        exact: false,
        isNewWindow: '1',
        icon: 'GridView',
        url: 'https://ropeg.kkp.go.id/login',
      },
    ]
  },
  {
    id: 'masterdata',
    title: 'Masterdata',
    messageId: 'Masterdata',
    type: 'nonGroup',
    icon: 'Storage',
    exact: false,
    url: '/masterdata'
  },
];

export const routesConfig = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    messageId: 'Dashboard',
    type: 'nonGroup',
    url: '/dashboard',
    icon: 'Dashboard',
  },
  {
    id: 'data-pribadi',
    title: 'Data Pribadi',
    messageId: 'Data Pribadi',
    type: 'nonGroup',
    url: '/data-pribadi',
    icon: 'Person',
  },
  {
    id: 'profil-talenta',
    title: 'Profil Talenta',
    messageId: 'Profil Talenta',
    type: 'nonGroup',
    url: '/profil-talenta',
    icon: 'AssignmentInd',
  },
  {
    id: 'laporan',
    title: 'Laporan',
    messageId: 'Laporan',
    type: 'group',
    icon: 'Assessment',
    children: [
      {
        id: 'rekapitulasi',
        title: 'Rekapitulasi',
        messageId: 'Rekapitulasi',
        type: 'collapse',
        exact: false,
        icon: 'Analytics',
        children: [
          {
            id: 'rekapitulasi-pegawai',
            title: 'Rekapitulasi Pegawai',
            messageId: 'Rekapitulasi Pegawai',
            type: 'item',
            exact: false,
            icon: 'Analytics',
            url: '/laporan-umum/rekapitulasi',
          },
          {
            id: 'rekapitulasi-formasi-peta-jabatan',
            title: 'Rekapitulasi Formasi Peta Jabatan',
            messageId: 'Rekapitulasi Formasi Peta Jabatan',
            type: 'item',
            exact: false,
            icon: 'Leaderboard',
            url: '/laporan-jumlah-jabatan-unit',
          },
          {
            id: 'rekapitulasi-jabatan-fungsional',
            title: 'Rekapitulasi Jabatan Fungsional',
            messageId: 'Rekapitulasi Jabatan Fungsional',
            type: 'item',
            exact: false,
            icon: 'Leaderboard',
            url: '/laporan-umum/jabfung/pejabat-fungsional',
          },
        ]
      },
      {
        id: 'daftar-nominatif-pegawai',
        title: 'Daftar Nominatif Pegawai',
        messageId: 'Daftar Nominatif Pegawai',
        type: 'item',
        exact: false,
        icon: 'Summarize',
        url: '/laporan-umum/laporan',
      },
      {
        id: 'grafik',
        title: 'Grafik',
        messageId: 'Grafik',
        type: 'item',
        exact: false,
        icon: 'PieChart',
        url: '/laporan-umum/grafik',
      },
    ],
  },
  {
    id: 'umpan-balik-360',
    title: 'Umpan Balik 360',
    messageId: 'Umpan Balik 360',
    type: 'nonGroup',
    exact: false,
    url: '/umpan-balik-360',
    icon: 'CreditScore',
  },
  {
    id: 'presensi',
    title: 'Presensi',
    messageId: 'Presensi',
    type: 'group',
    icon: 'CoPresent',
    children: [
       {
        id: 'dashboard-presensi-personal',
        title: 'Dashboard Pribadi',
        messageId: 'Dashboard Pribadi',
        icon: 'CoPresent',
        type: 'item',
        url: '/presensi/dashboard',
      },
      {
        id: 'e-presensi',
        title: 'E-Presensi Detail',
        messageId: 'E-Presensi Detail',
        type: 'item',
        isNewWindow: '1',
        icon: 'CoPresent',
        url: 'http://presensi.kkp.go.id:6080/presensi/report-pribadi',
      }     
    ]
  },
  {
    id: 'ipasn',
    title: 'IPASN',
    messageId: 'IPASN',
    type: 'group',
    icon: 'MilitaryTech',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        messageId: 'Dashboard',
        type: 'item',
        exact: true,
        isNewWindow: '1',
        icon: 'GridView',
        url: 'http://ropeg.kkp.go.id:4080/ip-asn',
      },
      {
        id: 'detai-ipasn',
        title: 'Detail',
        messageId: 'Detail',
        type: 'item',
        exact: false,
        isNewWindow: '1',
        icon: 'GridView',
        url: 'https://ropeg.kkp.go.id/login',
      },
    ]
  },
];

export const operatorRoutes = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    messageId: 'Dashboard',
    type: 'nonGroup',
    url: '/dashboard',
    icon: 'Dashboard',
  },
  {
    id: 'data-pegawai',
    title: 'Data Pegawai',
    messageId: 'Data Pegawai',
    type: 'group',
    icon: 'People',
    children: [
      {
        id: 'data-asn',
        title: 'Data Pegawai ASN',
        messageId: 'Data Pegawai ASN',
        type: 'item',
        exact: false,
        url: '/pegawai/asn',
      },
      {
        id: 'data-kontrak',
        title: 'Data Pegawai Kontrak',
        messageId: 'Data Pegawai Kontrak',
        type: 'item',
        exact: false,
        url: '/pegawai/kontrak',
      },
      {
        id: 'data-jpt-non-pns',
        title: 'Data Pegawai JPT Non PNS',
        messageId: 'Data Pegawai JPT Non PNS',
        type: 'item',
        exact: false,
        url: '/pegawai/jpt-non-pns',
      },
      {
        id: 'data-pjlp',
        title: 'Data Pegawai PJLP (Outsource)',
        messageId: 'Data Pegawai PJLP (Outsource)',
        type: 'item',
        exact: false,
        url: '/pegawai/pjlp',
      },
    ],
  },
  {
    id: 'profil-talenta',
    title: 'Profil Talenta',
    messageId: 'Profil Talenta',
    type: 'nonGroup',
    url: '/profil-talenta',
    icon: 'AssignmentInd',
  },
  {
    id: 'laporan',
    title: 'Laporan',
    messageId: 'Laporan',
    type: 'group',
    icon: 'Assessment',
    children: [
      {
        id: 'rekapitulasi',
        title: 'Rekapitulasi',
        messageId: 'Rekapitulasi',
        type: 'collapse',
        exact: true,
        icon: 'Analytics',
        children: [
          {
            id: 'rekapitulasi-pegawai',
            title: 'Rekapitulasi Pegawai',
            messageId: 'Rekapitulasi Pegawai',
            type: 'item',
            exact: true,
            url: '/laporan-umum/rekapitulasi',
          },
          {
            id: 'rekapitulasi-formasi-peta-jabatan',
            title: 'Rekapitulasi Formasi Peta Jabatan',
            messageId: 'Rekapitulasi Formasi Peta Jabatan',
            type: 'item',
            exact: true,
            url: '/laporan-jumlah-jabatan-unit',
          },
          {
            id: 'rekapitulasi-jabatan-fungsional',
            title: 'Rekapitulasi Jabatan Fungsional',
            messageId: 'Rekapitulasi Jabatan Fungsional',
            type: 'item',
            exact: false,
            icon: 'Leaderboard',
            url: '/laporan-umum/jabfung/pejabat-fungsional',
          },
        ]
      },
      {
        id: 'daftar-nominatif-pegawai',
        title: 'Daftar Nominatif Pegawai',
        messageId: 'Daftar Nominatif Pegawai',
        type: 'item',
        exact: false,
        icon: 'Summarize',
        url: '/laporan-umum/laporan',
      },
      {
        id: 'grafik',
        title: 'Grafik',
        messageId: 'Grafik',
        type: 'item',
        exact: false,
        icon: 'PieChart',
        url: '/laporan-umum/grafik',
      },
    ],
  },
  {
    id: 'manajemen',
    title: 'Tim Kerja',
    messageId: 'Tim Kerja',
    type: 'nonGroup',
    url: '/manajemen/anggota-tim-kerja',
    icon: 'Dashboard',
  },
  {
    id: 'monitoring',
    title: 'Monitoring',
    messageId: 'Monitoring',
    type: 'nonGroup',
    url: '/monitoring/data-asn',
    icon: 'TextSnippet',
  },
  {
    id: 'logbook',
    title: 'Logbook',
    messageId: 'Logbook',
    type: 'group',
    icon: 'LibraryBooks',
    children: [
      {
        id: 'aktivitas',
        title: 'Aktivitas',
        messageId: 'Aktivitas',
        type: 'item',
        exact: true,
        url: '/logbook/aktivitas',
      },
    ],
  },
  {
    id: 'ipasn',
    title: 'IPASN',
    messageId: 'IPASN',
    type: 'group',
    icon: 'MilitaryTech',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        messageId: 'Dashboard',
        type: 'item',
        exact: true,
        isNewWindow: '1',
        icon: 'GridView',
        url: 'http://ropeg.kkp.go.id:4080/ip-asn',
      },
      {
        id: 'detai-ipasn',
        title: 'Detail',
        messageId: 'Detail',
        type: 'item',
        exact: false,
        isNewWindow: '1',
        icon: 'GridView',
        url: 'https://ropeg.kkp.go.id/login',
      },
    ]
  },
  {
    id: 'masterdata',
    title: 'Masterdata',
    messageId: 'Masterdata',
    type: 'nonGroup',
    url: '/masterdata/unit-kerja',
    icon: 'Dashboard',
  },
  {
    id: 'pengaturan',
    title: 'Pengaturan',
    messageId: 'Pengaturan',
    type: 'group',
    icon: 'Dashboard',
    children: [
      {
        id: 'pengguna',
        title: 'Pengguna',
        messageId: 'Pengguna',
        type: 'item',
        exact: true,
        url: '/pengaturan/pengguna',
      },
      // {
      //   id: 'hak-akses',
      //   title: 'Hak Akses',
      //   messageId: 'Hak Akses',
      //   type: 'item',
      //   exact: true,
      //   url: '/pengaturan/hak-akses',
      // },
    ]
  },
];

export const viewerRoutes = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    messageId: 'Dashboard',
    type: 'nonGroup',
    url: '/dashboard',
    icon: 'Dashboard',
  },
  {
    id: 'data-pegawai',
    title: 'Data Pegawai',
    messageId: 'Data Pegawai',
    type: 'group',
    icon: 'People',
    children: [
      {
        id: 'data-asn',
        title: 'Data Pegawai ASN',
        messageId: 'Data Pegawai ASN',
        type: 'item',
        exact: false,
        url: '/pegawai/asn',
      },
      {
        id: 'data-kontrak',
        title: 'Data Pegawai Kontrak',
        messageId: 'Data Pegawai Kontrak',
        type: 'item',
        exact: false,
        url: '/pegawai/kontrak',
      },
      {
        id: 'data-jpt-non-pns',
        title: 'Data Pegawai JPT Non PNS',
        messageId: 'Data Pegawai JPT Non PNS',
        type: 'item',
        exact: false,
        url: '/pegawai/jpt-non-pns',
      },
      {
        id: 'data-pjlp',
        title: 'Data Pegawai PJLP (Outsource)',
        messageId: 'Data Pegawai PJLP (Outsource)',
        type: 'item',
        exact: false,
        url: '/pegawai/pjlp',
      },
      {
        id: 'laporan-khusus',
        title: 'Laporan Khusus',
        messageId: 'Laporan Khusus',
        type: 'collapse',
        children: [
          // {
          //   id: 'drh',
          //   title: 'Daftar Riwayat Hidup',
          //   messageId: 'Daftar Riwayat Hidup',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/drh',
          // },
          {
            id: 'pegawai-akan-pensiun',
            title: 'Daftar Pegawai akan Pensiun',
            messageId: 'Daftar Pegawai akan Pensiun',
            type: 'item',
            exact: false,
            url: '/pegawai/laporan-khusus/pegawai-akan-pensiun',
          },
          // {
          //   id: 'mutasi',
          //   title: 'Daftar Mutasi',
          //   messageId: 'Daftar Mutasi',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/mutasi',
          // },
          // {
          //   id: 'informasi-jabatan',
          //   title: 'Informasi Jabatan',
          //   messageId: 'Informasi Jabatan',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/informasi-jabatan',
          // },
          // {
          //   id: 'aktivitas-operator',
          //   title: 'Aktivitas Operator',
          //   messageId: 'Aktivitas Operator',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/aktivitas-operator',
          // },
          // {
          //   id: 'export-data-pegawai',
          //   title: 'Export Data Pegawai',
          //   messageId: 'Export Data Pegawai',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/export-data',
          // },
          // {
          //   id: 'surat-dp3-pegawai',
          //   title: 'Persuratan/Surat DP3 Pegawai',
          //   messageId: 'Persuratan/Surat DP3 Pegawai',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/surat-dp3-pegawai',
          // },
          {
            id: 'pegawai-tugas-izin-belajar',
            title: 'Daftar Pegawai Tugas Belajar',
            messageId: 'Daftar Pegawai Tugas Belajar',
            type: 'item',
            exact: false,
            url: '/pegawai/laporan-khusus/pegawai-tugas-izin-belajar',
          },
          // {
          //   id: 'rekapitulasi-pegawai-non-pns',
          //   title: 'Rekapitulasi Pegawai Non PNS',
          //   messageId: 'Rekapitulasi Pegawai Non PNS',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/rekapitulasi-pegawai-non-pns',
          // },
          // {
          //   id: 'data-pegawai-perlu-diperbaiki',
          //   title: 'Data Pegawai Perlu Diperbaiki',
          //   messageId: 'Data Pegawai Perlu Diperbaiki',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/data-pegawai-perlu-diperbaiki',
          // },
          // {
          //   id: 'daftar-nominatif',
          //   title: 'Daftar Nominatif',
          //   messageId: 'Daftar Nominatif',
          //   type: 'item',
          //   exact: false,
          //   url: '/pegawai/laporan-khusus/daftar-nominatif',
          // }
        ],
      },
    ],
  },
  {
    id: 'laporan',
    title: 'Laporan',
    messageId: 'Laporan',
    type: 'group',
    icon: 'Assessment',
    children: [
      {
        id: 'rekapitulasi',
        title: 'Rekapitulasi',
        messageId: 'Rekapitulasi',
        type: 'collapse',
        exact: true,
        icon: 'Analytics',
        children: [
          {
            id: 'rekapitulasi-pegawai',
            title: 'Rekapitulasi Pegawai',
            messageId: 'Rekapitulasi Pegawai',
            type: 'item',
            exact: true,
            icon: 'Analytics',
            url: '/laporan-umum/rekapitulasi',
          },
          {
            id: 'rekapitulasi-formasi-peta-jabatan',
            title: 'Rekapitulasi Formasi Peta Jabatan',
            messageId: 'Rekapitulasi Formasi Peta Jabatan',
            type: 'item',
            exact: true,
            icon: 'Analytics',
            url: '/laporan-jumlah-jabatan-unit',
          },
          {
            id: 'rekapitulasi-jabatan-fungsional',
            title: 'Rekapitulasi Jabatan Fungsional',
            messageId: 'Rekapitulasi Jabatan Fungsional',
            type: 'item',
            exact: false,
            icon: 'Leaderboard',
            url: '/laporan-umum/jabfung/pejabat-fungsional',
          },
        ]
      },
      {
        id: 'daftar-nominatif-pegawai',
        title: 'Daftar Nominatif Pegawai',
        messageId: 'Daftar Nominatif Pegawai',
        type: 'item',
        exact: false,
        icon: 'Summarize',
        url: '/laporan-umum/laporan',
      },
      // {
      //   id: 'laporan-jumlah-jabatan-unit',
      //   title: 'Laporan Jumlah Jabatan Unit',
      //   messageId: 'Laporan Jumlah Jabatan Unit',
      //   type: 'item',
      //   exact: false,
      //   icon: 'Leaderboard',
      //   url: '/laporan-jumlah-jabatan-unit',
      // },
      {
        id: 'grafik',
        title: 'Grafik',
        messageId: 'Grafik',
        type: 'item',
        exact: false,
        icon: 'PieChart',
        url: '/laporan-umum/grafik',
      },
    ],
  },
  {
    id: 'monitoring',
    title: 'Monitoring',
    messageId: 'Monitoring',
    type: 'nonGroup',
    url: '/monitoring/data-asn',
    icon: 'TextSnippet',
  },
  {
    id: 'manajemen',
    title: 'Tim Kerja',
    messageId: 'Tim Kerja',
    type: 'nonGroup',
    url: '/manajemen/anggota-tim-kerja',
    icon: 'Dashboard',
  },
  {
    id: 'ipasn',
    title: 'IPASN',
    messageId: 'IPASN',
    type: 'group',
    icon: 'MilitaryTech',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        messageId: 'Dashboard',
        type: 'item',
        exact: true,
        isNewWindow: '1',
        icon: 'GridView',
        url: 'http://ropeg.kkp.go.id:4080/ip-asn',
      },
      {
        id: 'detai-ipasn',
        title: 'Detail',
        messageId: 'Detail',
        type: 'item',
        exact: false,
        isNewWindow: '1',
        icon: 'GridView',
        url: 'https://ropeg.kkp.go.id/login',
      },
    ]
  },
  {
    id: 'pengaturan',
    title: 'Pengaturan',
    messageId: 'Pengaturan',
    type: 'group',
    icon: 'Dashboard',
    children: [
      {
        id: 'pengguna',
        title: 'Pengguna',
        messageId: 'Pengguna',
        type: 'item',
        exact: true,
        url: '/pengaturan/pengguna',
      },
      // {
      //   id: 'hak-akses',
      //   title: 'Hak Akses',
      //   messageId: 'Hak Akses',
      //   type: 'item',
      //   exact: true,
      //   url: '/pengaturan/hak-akses',
      // },
    ]
  },
];

export const operatorEselon1Routes = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    messageId: 'Dashboard',
    type: 'nonGroup',
    url: '/dashboard',
    icon: 'Dashboard',
  },
  {
    id: 'data-pegawai',
    title: 'Data Pegawai',
    messageId: 'Data Pegawai',
    type: 'group',
    icon: 'People',
    children: [
      {
        id: 'data-asn',
        title: 'Data Pegawai ASN',
        messageId: 'Data Pegawai ASN',
        type: 'item',
        exact: false,
        url: '/pegawai/asn',
      },
      {
        id: 'data-kontrak',
        title: 'Data Pegawai Kontrak',
        messageId: 'Data Pegawai Kontrak',
        type: 'item',
        exact: false,
        url: '/pegawai/kontrak',
      },
      {
        id: 'data-jpt-non-pns',
        title: 'Data Pegawai JPT Non PNS',
        messageId: 'Data Pegawai JPT Non PNS',
        type: 'item',
        exact: false,
        url: '/pegawai/jpt-non-pns',
      },
      {
        id: 'data-pjlp',
        title: 'Data Pegawai PJLP (Outsource)',
        messageId: 'Data Pegawai PJLP (Outsource)',
        type: 'item',
        exact: false,
        url: '/pegawai/pjlp',
      },
    ],
  },
  {
    id: 'profil-talenta',
    title: 'Profil Talenta',
    messageId: 'Profil Talenta',
    type: 'nonGroup',
    url: '/profil-talenta',
    icon: 'AssignmentInd',
  },
  {
    id: 'laporan',
    title: 'Laporan',
    messageId: 'Laporan',
    type: 'group',
    icon: 'Assessment',
    children: [
      {
        id: 'rekapitulasi',
        title: 'Rekapitulasi',
        messageId: 'Rekapitulasi',
        type: 'collapse',
        exact: true,
        icon: 'Analytics',
        children: [
          {
            id: 'rekapitulasi-pegawai',
            title: 'Rekapitulasi Pegawai',
            messageId: 'Rekapitulasi Pegawai',
            type: 'item',
            exact: true,
            icon: 'Analytics',
            url: '/laporan-umum/rekapitulasi',
          },
          {
            id: 'rekapitulasi-formasi-peta-jabatan',
            title: 'Rekapitulasi Formasi Peta Jabatan',
            messageId: 'Rekapitulasi Formasi Peta Jabatan',
            type: 'item',
            exact: true,
            icon: 'LeaderBoard',
            url: '/laporan-jumlah-jabatan-unit',
          },
        ]
      },
      {
        id: 'daftar-nominatif-pegawai',
        title: 'Daftar Nominatif Pegawai',
        messageId: 'Daftar Nominatif Pegawai',
        type: 'item',
        exact: false,
        icon: 'Summarize',
        url: '/laporan-umum/laporan',
      },
      {
        id: 'grafik',
        title: 'Grafik',
        messageId: 'Grafik',
        type: 'item',
        exact: false,
        icon: 'PieChart',
        url: '/laporan-umum/grafik',
      },
    ],
  },
  // {
  //   id: 'presensi',
  //   title: 'Presensi',
  //   messageId: 'Presensi',
  //   icon: 'CoPresent',
  //   type: 'nonGroup',
  //   url: '/presensi/dashboard',
  // },
  // {
  //   id: 'manajemen',
  //   title: 'Manajemen',
  //   messageId: 'Manajemen',
  //   type: 'nonGroup',
  //   url: '/manajemen/anggota-tim-kerja',
  //   icon: 'Dashboard',
  // },
  {
    id: 'monitoring',
    title: 'Monitoring',
    messageId: 'Monitoring',
    type: 'nonGroup',
    url: '/monitoring/data-asn',
    icon: 'TextSnippet',
  },
  {
    id: 'logbook',
    title: 'Logbook',
    messageId: 'Logbook',
    type: 'group',
    icon: 'LibraryBooks',
    children: [
      {
        id: 'aktivitas',
        title: 'Aktivitas',
        messageId: 'Aktivitas',
        type: 'item',
        exact: true,
        url: '/logbook/aktivitas',
      },
    ],
  },
  // {
  //   id: 'slks',
  //   title: 'SLKS',
  //   messageId: 'SLKS',
  //   type: 'nonGroup',
  //   url: '/slks/dashboard',
  //   icon: 'MilitaryTech',
  // },
  {
    id: 'masterdata',
    title: 'Masterdata',
    messageId: 'Masterdata',
    type: 'nonGroup',
    url: '/masterdata/unit-kerja',
    icon: 'Dashboard',
  },
  {
    id: 'pengaturan',
    title: 'Pengaturan',
    messageId: 'Pengaturan',
    type: 'group',
    icon: 'Dashboard',
    children: [
      {
        id: 'pengguna',
        title: 'Pengguna',
        messageId: 'Pengguna',
        type: 'item',
        exact: true,
        url: '/pengaturan/pengguna',
      },
      // {
      //   id: 'hak-akses',
      //   title: 'Hak Akses',
      //   messageId: 'Hak Akses',
      //   type: 'item',
      //   exact: true,
      //   url: '/pengaturan/hak-akses',
      // },
    ]
  },
];

export const penilaian360Routes = [
  {
    id: 'umpan-balik-360',
    title: 'Umpan Balik 360',
    messageId: 'Umpan Balik 360',
    type: 'nonGroup',
    exact: false,
    url: '/umpan-balik-360',
    icon: 'CreditScore',
  },
  {
    id: 'manajemen',
    title: 'Tim Kerja',
    messageId: 'Tim Kerja',
    type: 'nonGroup',
    url: '/manajemen/anggota-tim-kerja',
    icon: 'Dashboard',
  },
];